import React from 'react'
import { useNavigate } from "react-router";


let SpellEntry = ({spell}) => {
  let spellSchool = spell.spell_school;
  let navigate = useNavigate();

  spellSchool = String(spellSchool).charAt(0).toUpperCase() + String(spellSchool).slice(1);

  let openSpell = () => {

    navigate("/spell/" + spell.spell_id);
  }

  return (

    <tr className="spell-entry" onClick={openSpell}>
      <td>{spell.spell_name}</td>
      <td>{spellSchool}</td>
      <td>{spell.spell_class}</td>
      <td>{spell.short_description}</td>
      <td>{spell.source_name}</td>
    </tr>

  )
}

export default SpellEntry;